<!-- No Results -->

<!-- Content -->
@if (showModal) {
  <div
    class="mdsf-modal"
    id="modal">
    <nav [class.fixed]="showModal"
      class="mdsf-modal-navbar"
      id="mdsfModalNavbar">
      <!-- Search Form -->
      <form [formGroup]="searchForm" (ngSubmit)="onSubmit()" class="form-inline">
        <div class="input-group mr-2">
          <input #searchInput
            formControlName="searchString"
            autocomplete="off"
            class="form-control search"
            id="search"
            name="search"
            placeholder="{{ 'search_after' | translate }}"
            type="text">
          <div ngbDropdown autoClose="outside" class="d-inline-block input-group-append">
            <button class="btn btn-secondary" type="button" id="typeSelect" ngbDropdownToggle>{{ selectedFilterOption.label | translate }}</button>
            <div ngbDropdownMenu aria-labelledby="typeSelect">
              @for (type of typeFilterOptions; track type) {
                <button
                  ngbDropdownItem
                  type="button" [class.active]="selectedFilterOption === type"
                (click)="setTypeFilter(type)">{{type.label | translate}}</button>
              }
            </div>
          </div>
        </div>
        <button class="btn btn-light" type="submit">{{'search' | translate}}</button>
      </form>
      <!-- Close Button -->
      <button class="btn closebtn"
        (click)="modalControlService.closeModal()"
        title="{{ 'close_modal' | translate }}">
        <i class="fa fa-fw fa-close"></i>
      </button>
    </nav>
    <section class="mdsf-modal-content">
      <!-- Spinner -->
      @if (isSubmitted) {
        <medsurf-design-content-process-spinner class="text-black spinner"></medsurf-design-content-process-spinner>
      }
      <!-- Results -->
      @if ((searchControlFacade.nodeSearchResult$ | async); as nodeSearchResult) {
        @if (nodeSearchResult.total > 0) {
          <div class="mdsf-grid thumbnail-container scrollable">
            <!-- Grid Item -->
            @for (item of nodeSearchResult.items; track item) {
              <a
                (click)="modalControlService.closeModal()"
                [routerLink]="['/', 'node', item.id]"
                class="mdsf-thumbnail"
                [title]="item?.title">
                <div class="resource-type-icon"
                  [title]="mediaControlService.getMediaTypeLabel({ type: item?.mediaType }) | translate">
                  <span [class]="'fa ' + mediaControlService.getMediaTypeIcon({ type: item?.mediaType })"></span>
                </div>
                <div>
                  <img [src]="item?.media?.thumbnail ? mediaControlService.getUrl(item?.media, 'thumbnail') : '/assets/images/no-image.png'" />
                </div>
                <div class="description">
                  <div class="title truncate truncate-multiline" [innerHTML]="item?.title"></div>
                  <div class="breadcrumbs" [innerHTML]="item?.path.replaceAll('/', ' / ')"></div>
                </div>
              </a>
            }
          </div>
          <!-- Pagination -->
          <div class="d-flex justify-content-center mb-5">
            <ngb-pagination
              [page]="searchForm.value.first / searchForm.value.rows + 1"
              (pageChange)="onPageChange($event)"
              [maxSize]="3"
              [rotate]="true"
              [pageSize]="searchForm.value.rows"
              [collectionSize]="nodeSearchResult.total">
              <ng-template ngbPaginationPrevious><i class="fa fa-angle-left"></i></ng-template>
              <ng-template ngbPaginationNext><i class="fa fa-angle-right"></i></ng-template>
            </ngb-pagination>
          </div>
        } @else {
          <div class="d-flex justify-content-center">
            <h3 class="grid-header">{{ 'no-results' | translate}}</h3>
          </div>
        }
      }
    </section>
  </div>
}
